import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const knowledgeStore = useKnowledgeStore();
  const configStore = useConfigStore();
  const { knowledgeId } = to.params as { knowledgeId: string };
  const { force, skipOrdered, silent } = to.query;
  const fromLang = from.params.lang;
  const toLang = to.params.lang;

  if (to.name !== 'knowledge-viewer' || silent) return next();

  knowledgeStore.resetPath();

  const { knowledgeId: storedKnowledgeId } = storeToRefs(knowledgeStore);

  if (
    knowledgeId &&
    (knowledgeId !== storedKnowledgeId.value ||
      fromLang !== toLang ||
      force === '1')
  ) {
    const res = await knowledgeStore.getKnowledgeRootContent({
      knowledgeValue: knowledgeId,
      skipOrdered: skipOrdered === '1',
    });
  }
  configStore.initRoutesHistory();
  next();
};
